import React, { useEffect } from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import './App.css';
import { ThemeProvider } from './ThemeContext';
import { useConfig } from './ConfigContext';
import PasswordGate from './components/PasswordGate';
import Navigation from './components/Navigation';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';
import Landing from './pages/Landing';
import Pryme from './pages/Pryme';
import Apex from './pages/Apex';
import Benchmarks from './pages/Benchmarks';
import OnDevice from './pages/OnDevice';
import Markets from './pages/Markets';
import Cloud from './pages/Cloud';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsOfService from './pages/TermsOfService';
import Accessibility from './pages/Accessibility';
import Download from './pages/Download';
import ApexDemo from './pages/ApexDemo';
import DemoGate from './components/DemoGate';
import { ConfigProvider } from './ConfigContext';

function AppContent() {
  const config = useConfig();
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'instant' });
  }, [pathname]);


  const content = (
    <>
      <Navigation />
      <div className="App">
        <Routes>
          <Route path="/"              element={<Landing />} />
          <Route path="/pryme"         element={<Pryme />} />
          <Route path="/apex"          element={<Apex />} />
          <Route path="/benchmarks"    element={<Benchmarks />} />
          <Route path="/ondevice"      element={<OnDevice />} />
          <Route path="/markets"       element={<Markets />} />
          <Route path="/cloud"         element={<Cloud />} />
          <Route path="/privacy"       element={<PrivacyPolicy />} />
          <Route path="/terms"         element={<TermsOfService />} />
          <Route path="/accessibility" element={<Accessibility />} />
          <Route path="/download"      element={<Download />} />
          <Route path="/apex/demo"     element={<DemoGate><ApexDemo /></DemoGate>} />
        </Routes>
        <Footer />
        <ScrollToTop />
      </div>
    </>
  );

  return (
    <>
      {config.security.passwordProtection ? (
        <PasswordGate>{content}</PasswordGate>
      ) : (
        content
      )}
    </>
  );
}

function App() {
  return (
    <ThemeProvider>
      <ConfigProvider>
        <AppContent />
      </ConfigProvider>
    </ThemeProvider>
  );
}

export default App;